module.exports = __webpack_public_path__ + "img/public/SiteIcons/noMessageIcon.svg?cdb78131";